import { render } from "./PostStats.vue?vue&type=template&id=4a5b1f8a&scoped=true"
import script from "./PostStats.vue?vue&type=script&lang=js"
export * from "./PostStats.vue?vue&type=script&lang=js"

import "./post-stats.scss?vue&type=style&index=0&id=4a5b1f8a&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.7\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a5b1f8a"]])

export default __exports__